import {
  LIST_TEXT_TEMPLATE_REQUEST,
  LIST_TEXT_TEMPLATE_SUCCESS,
  LIST_TEXT_TEMPLATE_FAIL,
  LIST_TEXT_TEMPLATE_SUMMARY_REQUEST,
  LIST_TEXT_TEMPLATE_SUMMARY_SUCCESS,
  LIST_TEXT_TEMPLATE_SUMMARY_FAIL,
  CREATE_TEXT_TEMPLATE_REQUEST,
  CREATE_TEXT_TEMPLATE_SUCCESS,
  CREATE_TEXT_TEMPLATE_FAIL,
  DETAIL_TEXT_TEMPLATE_REQUEST,
  DETAIL_TEXT_TEMPLATE_SUCCESS,
  DETAIL_TEXT_TEMPLATE_FAIL,
  UPDATE_TEXT_TEMPLATE_REQUEST,
  UPDATE_TEXT_TEMPLATE_SUCCESS,
  UPDATE_TEXT_TEMPLATE_FAIL,
  DELETE_TEXT_TEMPLATE_REQUEST,
  DELETE_TEXT_TEMPLATE_SUCCESS,
  DELETE_TEXT_TEMPLATE_FAIL,
  RESET_TEXT_TEMPLATE
} from '../../constants/text-template'

const initialState = {
  loading: false,
  loadingCreate: false,
  loadingUpdate: false,
  loadingDelete: false,
  loadingDetail: false,
  loadingSummary: false,
  textTemplates: [],
  textTemplatesSummary: [],
  textTemplate: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const listTextTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_TEXT_TEMPLATE_REQUEST:
      return { ...state, loading: true }
    case LIST_TEXT_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        textTemplates: action.payload,
        pageable: action.pageable
      }
    case LIST_TEXT_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        textTemplates: action?.dummy
      }
    case LIST_TEXT_TEMPLATE_SUMMARY_REQUEST:
      return { ...state, loadingSummary: true }
    case LIST_TEXT_TEMPLATE_SUMMARY_SUCCESS:
      return {
        ...state,
        loadingSummary: false,
        textTemplatesSummary: action.payload
      }
    case LIST_TEXT_TEMPLATE_SUMMARY_FAIL:
      return {
        ...state,
        loadingSummary: false,
        error: action.payload
      }
    case CREATE_TEXT_TEMPLATE_REQUEST:
      return { ...state, loadingCreate: true, error: '' }
    case CREATE_TEXT_TEMPLATE_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_TEXT_TEMPLATE_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_TEXT_TEMPLATE_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_TEXT_TEMPLATE_SUCCESS:
      return { ...state, loadingDetail: false, textTemplate: action.payload }
    case DETAIL_TEXT_TEMPLATE_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case UPDATE_TEXT_TEMPLATE_REQUEST:
      return { ...state, loadingUpdate: true, error: '' }
    case UPDATE_TEXT_TEMPLATE_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_TEXT_TEMPLATE_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_TEXT_TEMPLATE_REQUEST:
      return { ...state, loadingDelete: true, error: '' }
    case DELETE_TEXT_TEMPLATE_SUCCESS:
      return { ...state, loadingDelete: false, error: '' }
    case DELETE_TEXT_TEMPLATE_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case RESET_TEXT_TEMPLATE:
      return { ...state, loading: false, error: null }
    default:
      return state
  }
}

export default listTextTemplateReducer
